import React, { useState } from 'react'
import { Alert, AlertDescription, AlertIcon, Button, HStack, Stack, Text } from '@chakra-ui/react'

import axios from 'lib/axios'

import InfoHint from '../components/InfoHint'
import { getErrorMessage } from '../types'

type Props = {
  statementEndDate: string
}

const SnapshotRebuild = ({ statementEndDate }: Props) => {
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const onTrigger = async () => {
    try {
      setIsLoading(true)
      setError('')
      setSuccess('')
      await axios.post('/admin/system/topic_publish', {
        topic: 'statements-initiate-backup-and-rebuild',
        message: statementEndDate ? { statementEndDate } : {}
      })
      setSuccess('Snapshot & rebuild initiated. Check #dagger-alerts for completion updates.')
    } catch (err: any) {
      setError(getErrorMessage(err))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Stack spacing={3}>
      <Text>
        This triggers statements snapshot + rebuild from staging into final tables. The current
        cloud function uses the month after the selected Statement End Date for snapshot slugging.
        <InfoHint label='Snapshot & Rebuild writes the latest staged calculator outputs into property_financials_final and creates snapshots used for monthly adjustment comparisons. Snapshot naming uses the month immediately after Statement End Date when provided.' />
      </Text>
      <HStack spacing={1} alignSelf='flex-start' alignItems='center'>
        <Button
          colorScheme='teal'
          variant='outline'
          onClick={onTrigger}
          isDisabled={isLoading || !statementEndDate}
          alignSelf='flex-start'
        >
          Trigger Snapshot & Rebuild
        </Button>
        <InfoHint label='Publishes topic statements-initiate-backup-and-rebuild. Wait for completion confirmation (for example in #dagger-alerts) before moving to downstream sync/upload steps.' />
      </HStack>
      {error && (
        <Alert status='error'>
          <AlertIcon />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      {success && (
        <Alert status='success'>
          <AlertIcon />
          <AlertDescription>{success}</AlertDescription>
        </Alert>
      )}
    </Stack>
  )
}

export default SnapshotRebuild
